<template>
  <div style="height: 100%">
    <el-row style="height: 100%;width: 100%;margin-bottom: 20px;overflow-y: auto">
      <label style="padding: 20px 0 0 30px;">暖通设备运行实时参数</label>
      <el-carousel v-if="deviceInfoList.length>0" :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0">
        <el-carousel-item :key="item.spaceId" v-for="item in deviceInfoList">
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;margin-top: 20px;">
            <el-row style="height: 100%;width: 100%;display: flex;flex-direction: column;">
              <el-col :span="24" style="color: #07E6F8;font-size: 14px;margin:0 0 2% 10%"><span
                class="circleClass"></span>
                {{ item.deviceName }}
              </el-col>
              <el-col :span="24"
                      style="height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center">
                <el-row class="rowClass"
                        style="display: flex;flex-direction: row;align-items: center;"
                        v-for="(item,index) in item.alternateDevicePointList" :key="index">
                  <el-col :span="20" style="font-size: 14px">{{ item.pointName }}</el-col>
                  <el-col style="width: 100px" v-if="item.pointValue!=='异常'" class="fontBlue">
                    {{ item.pointValue ? item.pointValue : '--' }}
                  </el-col>
                  <el-col style="width: 100px" v-else class="fontRed">{{
                      item.pointValue ? item.pointValue : '--'
                    }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div v-else style="height: 100%;padding-top: 20%">
        <no-data></no-data>
      </div>
    </el-row>
  </div>
</template>

<script>

import {getList} from '@/network/alternate_device'
import NoData from "@/components/NoData";

export default {
  name: "warmDeviceRealTimeParameter",
  data() {
    return {
      deviceInfoList: []
    };
  },
  components:{
    NoData
  },
  mounted() {
    this.getList()
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getWarmDeviceRealTime:5000': this.getList})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getWarmDeviceRealTime')
  },
  methods: {
    getList() {
      getList(true).then(res => {
        if (res.code === 0 && res.data !== null) {
          this.deviceInfoList = res.data
        }
      })
    }
  }
}
</script>

<style scoped>

label {
  font-weight: bold;
  color: #01EFFD;
}

.rowClass {
  height: 28px;
  line-height: 28px;
  width: 75%;
  margin-bottom: 5px;
  background: linear-gradient(90deg, rgba(41, 155, 255, 0) 0%, rgba(41, 155, 255, 0.1) 52%, rgba(41, 155, 255, 0) 100%);
  border-radius: 3px 3px 3px 3px;
}

.fontBlue {
  width: 16px;
  height: 22px;
  font-size: 16px;
  color: #299BFF;
}

.fontRed {
  width: 16px;
  height: 22px;
  font-size: 16px;
  color: #F95453;
}

.circleClass {
  display: inline-block;
  height: 8px;
  width: 8px;
  opacity: 0.8;
  border-radius: 50%;
  background: #07E6F8;
}
</style>
